// src/routes/PrivateRoute.tsx
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

interface Props {
  children: JSX.Element;
}

const PrivateRoute = ({ children }: Props) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
      setLoading(false);
    });

    return () => unsubscribe(); // clean up
  }, []);

  if (loading) return null; // or spinner

  return authenticated ? children : <Navigate to="/admin/login" replace />;
};

export default PrivateRoute;
